import request from './http'
//请求订阅
export function getSubscript(data) {
        return request({
            url: '/marketall/msgSub/subscript',
            method: 'post',
            data
        })
}
//订阅列表
export function getSubscriptList(data) {
    return request({
        url: '/marketall/msgSub/list',
        method: 'post',
        data
    })
}
//退订
export function getSubscriptDelete(data) {
    return request({
        url: '/marketall/msgSub/cancel',
        method: 'post',
        data
    })
}